import React, { Component } from 'react';
import { Mutation } from '@apollo/react-components';
import Seo from '$components/Seo';
import { gql } from '@apollo/client';
import AuthLayout from '$components/layout/AuthLayout';
import routes from '@achievable-me/tundra-wizard/routes';
import ForgotPasswordForm from './ForgotPasswordForm';

const FORGOT_PASSWORD = gql`
  mutation ForgotPassword($input: ForgotPasswordInput!) {
    forgotPassword(input: $input) {
      email
    }
  }
`;

class ForgotPassword extends Component {
  render() {
    return (
      <AuthLayout>
        <Seo
          title="Forgot password"
          canonical={routes.auth.forgotPassword}
          description="If you've forgot your password, you can reset it here."
        />
        <Mutation mutation={FORGOT_PASSWORD}>
          {(forgotPassword, { loading, data }) => {
            if (!data) {
              return (
                <ForgotPasswordForm forgotPassword={forgotPassword} loading={loading} />
              );
            }

            const {
              forgotPassword: { email },
            } = data;

            return (
              <div style={{ textAlign: 'center' }}>
                Password reset instructions were sent to <b>{email}</b>.<br />
                <br />
                You may close this window.
              </div>
            );
          }}
        </Mutation>
      </AuthLayout>
    );
  }
}

export default ForgotPassword;
